import script from "./category-item.vue?vue&type=script&setup=true&lang=js"
export * from "./category-item.vue?vue&type=script&setup=true&lang=js"

import "./category-item.vue?vue&type=style&index=0&id=bcb5f04e&lang=scss&scoped=true"

import exportComponent from "/data/project/activity-v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcb5f04e"]])

export default __exports__